import { client } from '../../../services/apiClient';
import { getDefaultRange } from '../../../utils/utils';
import { format } from 'date-fns';
import { PdfReportResponse } from '../../../models/report/PdfReportResponse';
import { PeriodType } from '../../../types/prompt/PeriodType';

export const REPORT_ENDPOINT = '/report';

export const getReport = async (
  projectId: number,
  period: PeriodType,
  from?: Date | null,
  to?: Date | null
): Promise<PdfReportResponse> => {
  const defaultRange = getDefaultRange();
  from = from ? new Date(from) : defaultRange[0];
  to = to ? new Date(to) : defaultRange[1];

  const formattedFrom = format(from, 'yyyy-MM-dd');
  const formattedTo = format(to, 'yyyy-MM-dd');

  const { data } = await client(true, true).get<PdfReportResponse>(
    `${REPORT_ENDPOINT}/${projectId}/${period}/${formattedFrom}/${formattedTo}`
  );
  return data;
};
